import { Button } from 'antd';
import styled from 'styled-components';

const CommentsListContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;
  height: calc(100% - 480px);
  overflow: auto;
  padding: 16px;
  position: relative;
`;

const NoCommentFoundContainer = styled.div`
  display: flex;
  height: 100%;
  width: 100%;
  justify-content: center;
  align-items: center;
  color: #445260;
`;

const CommentsContainer = styled.div`
  height: 100%;
`;

const AddCommentContainer = styled.div`
  display: flex;
  gap: 8px;
  padding: 16px;
`;

const CommentsSearchContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 16px 16px 12px 16px;
  gap: 10px;
`;

export default {
  CommentsContainer,
  AddCommentContainer,
  CommentsSearchContainer,
  CommentsListContainer,
  NoCommentFoundContainer,
};
